// extracted by mini-css-extract-plugin
export default {"element":"CommonBlock_element__EJQAB","data":"CommonBlock_data__WoNbx","icon":"CommonBlock_icon__47pYI","text":"CommonBlock_text__gwd9y"};